import axiosClient from "../api/axiosClient";

type LoginPayload = { username: string; password: string };

export const authService = {
  login: async (payload: LoginPayload) => {
    const res = await axiosClient.post("/login", payload);
    return res.data;
  },

  logout: async () => {
    try {
      await axiosClient.post("/logout"); 
    } catch (err) {}
    // localStorage.removeItem("token");
    // localStorage.removeItem("user");
  },
};

/* SEND OTP */
export const sendOtpApi = (data: { email: string }) => {
  return axiosClient.post("/send-otp", data);
};

/* VERIFY OTP */
export const verifyOtpApi = (data: { email: string; otp: string }) => {
  return axiosClient.post("/verify-otp", data);
};

/* RESET PASSWORD */
export const resetPasswordApi = (data: {
  reset_token: string;
  password: string;
  password_confirmation: string;
}) => {
  return axiosClient.post("/reset-password", data);
};

export default authService;
